import { useRouter } from 'expo-router';
import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useSubmitApplication from 'features/application/hooks/useSubmitApplication';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import LegalAgreements from 'features/application/screens/LegalAgreements/LegalAgreements';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';

const LegalAgreementsWrapper = () => {
  const router = useRouter();
  const {
    application,
    reExecuteQuery,
    fetching,
    error,
    hasApplicationLoaded,
    isReapplication,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.LEGAL_AGREEMENT,
  });
  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
  } = useUpdateApplication({
    applicationId: application?.id,
    sourceName: SourceName.LEGAL_AGREEMENT,
  });
  const {
    isSubmitApplicationSuccess,
    isSubmitApplicationLoading,
    submitApplication,
    submitApplicationMutationResult,
    submitApplicationErrorMessage,
  } = useSubmitApplication({
    applicationId: application?.id,
    sourceName: SourceName.LEGAL_AGREEMENT,
  });

  return (
    <LegalAgreements
      isSubmitApplicationSuccess={isSubmitApplicationSuccess}
      applicationId={application?.id}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      onTryAgain={() => {
        if (error) {
          reExecuteQuery();
        } else if (submitApplicationErrorMessage) {
          // Submission failed, go back and let them retry
          router.replace('/signup/verify-ssn');
        }
      }}
      fetching={fetching}
      error={error || submitApplicationErrorMessage}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      isSubmitApplicationLoading={isSubmitApplicationLoading}
      submitApplication={submitApplication}
      submitApplicationMutationResult={submitApplicationMutationResult}
      backRoute="/signup/verify-ssn"
    />
  );
};

export default LegalAgreementsWrapper;
